module.exports = __webpack_public_path__ + "img/placeholder.77386ad4.png";